/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import every from 'lodash/every';
import some from 'lodash/some';
import find from 'lodash/find';

export function allSuccess(...results) {
  return every(results, r => r.status === 'success');
}

export function someFailure(...results) {
  return some(results, r => r.status === 'failure');
}

export function findFailure(...results) {
  return find(results, r => r.status === 'failure');
}

export function somePending(...results) {
  return some(results, r => r.status === 'pending');
}

export function pending(result = {}) {
  return result.status === 'request' || result.status === 'pending';
}




// WEBPACK FOOTER //
// ./src/utils/api/status.js